import Projeto01 from '../assets/Movies/Projeto01.mp4'
import Projeto02 from '../assets/Movies/Projeto02.mp4'
import Projeto03 from '../assets/Movies/Projeto03.mp4'
import Projeto04 from '../assets/Movies/Projeto04.mp4'
import Projeto05 from '../assets/Movies/Projeto05.mp4'
import Projeto06 from '../assets/Movies/Projeto06.mp4'
import Projeto07 from '../assets/Movies/Projeto07.mp4'
import Projeto08 from '../assets/Movies/Projeto08.mp4'

export const projectsArray = [
    {
        title: "Mini Projeto - We are criatives (HTML e CSS)",
        video: Projeto01,
        descricao: "Mini projeto desenvolvido durante o curso da cubos academy para a prática de HTML CSS",
        codigo: "https://github.com/MichaelFranklyn/Mini-Projetos-HTML-CSS"

    },
    {
        title: "Projeto - Portfólio (HTML e CSS)",
        video: Projeto02,
        descricao: "Projeto desenvolvido durante o curso da cubos academy que consistia em produzir um portfólio profissional usando HTML e CSS",
        codigo: "https://github.com/MichaelFranklyn/Portfolio-Profissional"
    },
    {
        title: "Mini projeto - Fotos com like (HTML, CSS e DOM)",
        video: Projeto03,
        descricao: "Mini projeto desenvolvido durante o curso da cubos academy que consistia em produzir uma mini rede social usando HTML, CSS e DOM",
        codigo: "https://github.com/MichaelFranklyn/Mini-Projetos-HTML-CSS-DOM-"
    },
    {
        title: "Projeto - Cubos Flix (HTML, CSS e DOM)",
        video: Projeto04,
        descricao: "Projeto desenvolvido durante o curso da cubos academy que consistia em produzir uma mini streaming de videos usando HTML, CSS e DOM",
        codigo: "https://github.com/MichaelFranklyn/Cubos-Flix"
    },
    {
        title: "Mini Projeto - Cubos Puzzle (React.js)",
        video: Projeto05,
        descricao: "Mini projeto desenvolvido durante o curso da cubos academy que consistia em produzir um quebra-cabeça usando os conhecimentos de React.js",
        codigo: "https://github.com/MichaelFranklyn/Mini-Projeto-01---React-JS"
    },
    {
        title: "Mini Projeto - Cubos Player (React.js)",
        video: Projeto06,
        descricao: "Mini projeto desenvolvido durante o curso da cubos academy que consistia em produzir um player de músicas usando os conhecimentos de React.js",
        codigo: "https://github.com/MichaelFranklyn/Mini-Projeto-02---React-JS"
    },
    {
        title: "Projeto - Dindin (React.js)",
        video: Projeto07,
        descricao: "Projeto desenvolvido durante o curso da cubos academy que consistia em produzir uma aplicação integrada com o backend simulando um site de controle de finanças usando os conhecimentos de React.js e conhecimentos de Node.js no backend",
        codigo: "https://github.com/MichaelFranklyn/API-Controle-Financeiro"
    },
    {
        title: "Projeto - Lorem Ipsum (React.js)",
        video: Projeto08,
        descricao: "Projeto desenvolvido durante o curso da cubos academy que consistia em produzir uma aplicação integrada com o backend simulando um site para controle de clientes e cobranças de uma empresa usando os conhecimentos de React.js e conhecimentos de Node.js no backend",
        codigo: "https://github.com/MichaelFranklyn/Projeto-Final---Cubos-Academy"
    }
]